class LWVideo extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const src = this.escape(this.getAttribute('src') || '');
        const title = this.escape(this.getAttribute('title') || 'Video');
        const poster = this.escape(this.getAttribute('poster') || '');
        const posterAttr = poster ? ` poster="${poster}"` : '';
        let videoHTML = '';

        if (src.includes('youtube.com') || src.includes('youtu.be')) {
            const raw = this.getAttribute('src') || '';
            const id = this.escape(raw.split('v=')[1] || raw.split('/').pop() || '');
            videoHTML = `<iframe src="https://www.youtube.com/embed/${id}" title="${title}" allowfullscreen></iframe>`;
        } else if (src.includes('vimeo.com')) {
            const raw = this.getAttribute('src') || '';
            const id = this.escape(raw.split('/').pop() || '');
            videoHTML = `<iframe src="https://player.vimeo.com/video/${id}" title="${title}" allowfullscreen></iframe>`;
        } else {
            videoHTML = `<video controls playsinline preload="none" src="${src}"${posterAttr}></video>`;
        }

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
                margin-bottom: 20px;
            }
            .video-wrapper {
                position: relative;
                padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
                height: 0;
                overflow: hidden;
                border-radius: 8px;
                background: #000;
            }
            .video-wrapper iframe, 
            .video-wrapper video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 0;
                object-fit: cover;
                background: #111;
            }
        </style>
        <div class="video-wrapper">
            ${videoHTML}
        </div>
        `;
    }

    escape(value) {
        return String(value)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;');
    }
}

customElements.define('lw-video', LWVideo);